export type SocialPlatform = "instagram" | "linkedin" | "youtube" | "x" | "facebook" | "tiktok";

export type SocialLink = {
  platform: SocialPlatform;
  label: string;
  href: string;
};

export const SOCIAL_LINKS: SocialLink[] = [
  { platform: "instagram", label: "Instagram", href: "https://instagram.com/konakla_co" },
  { platform: "linkedin", label: "LinkedIn", href: "https://linkedin.com/company/konakla" },
  { platform: "youtube", label: "YouTube", href: "https://youtube.com/@konakla" },
  { platform: "x", label: "X", href: "https://x.com/konaklaco" },
  { platform: "facebook", label: "Facebook", href: "https://facebook.com/konaklaco" },
  { platform: "tiktok", label: "TikTok", href: "https://tiktok.com/@konaklaco" },
];
